
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30683',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30683",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.55182",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8253",
  "hubspot-dlb": "static-2.1877",
  "HubStyleTokens": "static-2.11708",
  "I18n": "static-7.1654",
  "quartz": "static-1.7338",
  "quartz-config": "static-1.1116",
  "quartz-core": "static-1.6557",
  "react-dlb": "static-1.84",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.43",
  "reselect": "static-3.8",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.860",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.55169",
  "feedback-utils": "static-1.55173",
  "forms-embed-utils-lib": "static-1.4693",
  "forms-utils-lib": "static-1.12989",
  "foundations-assets": "static-1.5102",
  "foundations-components": "static-1.8353",
  "foundations-theming": "static-1.4679",
  "hub-http": "static-1.6440",
  "hubspot-url-utils": "static-1.4282",
  "HubStyle": "static-2.12015",
  "icons": "static-2.672",
  "immutable": "static-2.83",
  "quick-fetch": "static-1.4075",
  "raven": "static-3.5925",
  "react": "static-7.190",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.75",
  "react-rhumb": "static-1-redact-emails-from-unexpected-route-pathname.6",
  "react-select-plus": "static-1.108",
  "react-utils": "static-2.5499",
  "react-virtualized": "static-2.103",
  "redux": "static-4.16",
  "StyleGuideUI": "static-3.492",
  "tinymce-plugins": "static-1.58074",
  "transmute": "static-2.85",
  "ui-images": "static-2.1222",
  "UIComponents": "static-3.8654",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9849",
  "styled-components": "static-2.94",
  "bend-plugin-trellis-migration": "static-1.3559",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3615",
  "quartz-webpack": "static-1.3562",
  "foundations-theming-specialty": "static-1.2395",
  "property-description-translator": "static-1.4065",
  "HeadJS": "static-2.784",
  "framer-motion": "static-1.75",
  "hs-test-utils-bend-plugin": "static-1.3364",
  "msw": "static-1.39",
  "testing-library": "static-1.155",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.226",
  "moment-timezone": "static-5.86",
  "jasmine": "static-4.4546",
  "jasmine-runner": "static-1.6676",
  "dispatcher": "static-1.140",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.862",
  "hubspotter-http": "static-1.4808",
  "mobile-manifest-mixins": "static-1.559",
  "module-federation": "static-1.29",
  "quartz-auth": "static-1.1013",
  "quartz-head": "static-1.1003",
  "quartz-i18n": "static-1.1013",
  "quartz-routing": "static-1.768",
  "quartz-test": "static-1.1013",
  "quartz-tracking": "static-1.717",
  "trellis-components": "static-1.2428",
  "ui-fonts": "static-1.970",
  "usage-tracker-container": "static-1.7574",
  "usage-tracker-core": "static-1.7434",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.161",
  "conversations-skeleton-state": "static-1.7476",
  "reference-resolvers": "static-1.8409",
  "sanitize-text": "static-1.8375",
  "PatternValidationJS": "static-1.3124",
  "ReduxMessenger": "static-2.10592",
  "sanitize": "static-1.4703",
  "outpost": "static-1.4389",
  "rpc-client-utils": "static-1.4889",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4622",
  "floating-ui": "static-1.60",
  "hs-story-utils": "static-1.9654",
  "react-aria": "static-1.69",
  "react-create-root-preference": "static-1.55",
  "tanstack-table": "static-1.58",
  "trellis-assets": "static-1.2409",
  "bend-plugin-foundations-theming": "static-1.3162",
  "foundations-theming-base": "static-1.3664",
  "stylex": "static-1.37",
  "hs-locale-management": "static-1.240",
  "csstype": "static-1.50",
  "web-vitals": "static-1.9",
  "ai-components-ui-library": "static-1.9538",
  "atom": "static-1.5304",
  "codemirror": "static-5.98",
  "content-assistance-lib": "static-1.8105",
  "ContentUtils": "static-1.69009",
  "data-token-picker": "static-1.16788",
  "file-manager-components": "static-1.24309",
  "FileManagerCore": "static-1.39808",
  "FileManagerLib": "static-1.39949",
  "frontend-preferences-client": "static-1.8155",
  "hub-http-contrib": "static-1.3267",
  "interframe": "static-3.4982",
  "layout-dnd-components": "static-1.12861",
  "layout-dnd-utils": "static-1.11836",
  "property-translator": "static-1.5621",
  "react-codemirror": "static-1.10867",
  "react-colorpicker": "static-2.10435",
  "reference-resolvers-lite": "static-1.8325",
  "rich-text-lib": "static-1.20207",
  "tinymce-data": "static-1.41045",
  "tinymce-themes": "static-1.56930",
  "ui-addon-emoji-picker": "static-1.10113",
  "ui-addon-sales-email": "static-1.5440",
  "ui-brand-identity-lib": "static-1.16146",
  "bender-build-tools": "static-1.3347",
  "hub-http-shared-msw-handlers": "static-1.10491",
  "hubspotter-http-shared-msw-handlers": "static-1.10489",
  "usage-tracker-session-replay": "static-1.5270",
  "base-ui": "static-1.17",
  "react-day-picker": "static-1.6",
  "trellis-theming": "static-1.1183",
  "tanstack-virtual": "static-1.35",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.299",
  "chirp-fetch": "static-1.2114",
  "chatspot-core": "static-1.22518",
  "copilot-toolkit": "static-1.11703",
  "customer-data-objects-ui-components": "static-1.13258",
  "data-fetching-client": "static-1.9884",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.4983",
  "ui-addon-video-player": "static-1.8934",
  "ui-coaching-tips": "static-1.29174",
  "usage-tracker": "static-1.7584",
  "cms-field-types": "static-1.5041",
  "content-icons-ui": "static-1.2295",
  "integrations-lib": "static-1.16875",
  "customer-data-objects": "static-1.7912",
  "apollo-dlb": "static-3.86",
  "breeze-engine-lib": "static-1.1521",
  "apollo-link-hub-http": "static-2.4884",
  "apollo-stack-hubspot": "static-3.89",
  "graphql": "static-1.85",
  "immer": "static-1.94",
  "immerable": "static-1.4378",
  "ui-addon-iframeable": "static-1.9304",
  "video-components-external": "static-1.12002",
  "video-data-lib": "static-1.35660",
  "breeze-artifacts-sdk": "static-1.117",
  "audio-components": "static-1.6247",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29704",
  "FileManagerImages": "static-1.37460",
  "foundations-components-legacy": "static-1.1378",
  "html-to-image": "static-1.57",
  "react-immutable-proptypes": "static-2.8",
  "redux-toolkit": "static-1.7",
  "salesImages": "static-1.530",
  "ui-universal-auth": "static-1.9250",
  "urlinator": "static-1.4760",
  "video-components": "static-1.14004",
  "video-embed": "static-1.36494",
  "ts-schema": "static-1.4237",
  "ContentData": "static-1.69084",
  "layout-data-lib": "static-1.10161",
  "react-dnd-compat": "static-1.4842",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1771",
  "external-options-client-types": "static-1.4285",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.7120",
  "hs-promise-utils": "static-1.5823",
  "inbound-db-properties-service-client": "static-1.4004",
  "NamespacedHubStyle": "static-2.9208",
  "growth-onboarding-confetti": "static-1.3288",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11374",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5707",
  "magpie-types": "static-1.5167",
  "simple-logging-lib": "static-1.3277",
  "avatar-components": "static-1.2724",
  "customer-data-ui-utilities": "static-1.10053",
  "growth-onboarding-feedback-components": "static-1.6809",
  "flux-actions": "static-1.357",
  "hubspot-apollo-client": "static-1.5104",
  "integrations-error-boundary-lib": "static-1.14290",
  "integrations-tracking-lib": "static-1.5835",
  "laboratory-lib": "static-3.7378",
  "native-integrations-shared-strings": "static-1.8004",
  "redux-observable": "static-1.11",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10490",
  "unified-auth": "static-1.764",
  "breeze-engine-chat-components": "static-1.499",
  "breeze-engine-core": "static-1.799",
  "ably": "static-2.2",
  "highlight.js": "static-1.82",
  "navigation-messaging": "static-1.8011",
  "content-media-composition-data-lib": "static-1.13044",
  "content-media-compositions": "static-2.17051",
  "idb-keyval": "static-1.47",
  "media-bridge-lib": "static-1.19309",
  "unified-auth-core-lib": "static-1.1046",
  "social-insights-client-types": "static-1.22667",
  "advanced-menus-core": "static-1.15487",
  "advanced-menus-lib": "static-1.12372",
  "ExportDialog": "static-6.10607",
  "ui-memberships-settings-lib": "static-1.34669",
  "conditional-properties-service-client": "static-1.3956",
  "crm-pipelines-api-client-types": "static-1.4294",
  "fdsr-migration-layer": "static-1.239",
  "framework-builder-read-service-client": "static-1.4165",
  "framework-data-schema-quick-fetch": "static-1.7025",
  "inbound-db-meta-service-client": "static-1.3718",
  "multi-currency-client-types": "static-1.3850",
  "persist-promise": "static-1.3928",
  "foundations-components-test-utils": "static-1.5836",
  "reactive-lib": "static-1.947",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.563",
  "universal-page-editor-lib": "static-1.3237",
  "adobe-sign-auth-lib": "static-1.311",
  "ads-unified-auth-lib": "static-1.887",
  "google-sheets-integration-lib": "static-1.890",
  "microsoft-drive-integration-lib": "static-1.1023",
  "surveymonkey-integration-lib": "static-1.334",
  "slack-ui-library": "static-1.10622",
  "js-cookie": "static-1.18",
  "fsm": "static-1.3964",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15486",
  "simple-menus-lib": "static-1.17003",
  "crm-record-cards-service-types": "static-1.3739",
  "location-customization-utils-lib": "static-1.9949",
  "react-flip-move": "static-1.74"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30683",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.55182",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8253",
  "hubspot-dlb": "/hubspot-dlb/static-2.1877",
  "HubStyleTokens": "/HubStyleTokens/static-2.11708",
  "I18n": "/I18n/static-7.1654",
  "quartz": "/quartz/static-1.7338",
  "quartz-config": "/quartz-config/static-1.1116",
  "quartz-core": "/quartz-core/static-1.6557",
  "react-dlb": "/react-dlb/static-1.84",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reselect": "/reselect/static-3.8",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.860",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.55169",
  "feedback-utils": "/feedback-utils/static-1.55173",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4693",
  "forms-utils-lib": "/forms-utils-lib/static-1.12989",
  "foundations-assets": "/foundations-assets/static-1.5102",
  "foundations-components": "/foundations-components/static-1.8353",
  "foundations-theming": "/foundations-theming/static-1.4679",
  "hub-http": "/hub-http/static-1.6440",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4282",
  "HubStyle": "/HubStyle/static-2.12015",
  "icons": "/icons/static-2.672",
  "immutable": "/immutable/static-2.83",
  "quick-fetch": "/quick-fetch/static-1.4075",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.190",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.75",
  "react-rhumb": "/react-rhumb/static-1-redact-emails-from-unexpected-route-pathname.6",
  "react-select-plus": "/react-select-plus/static-1.108",
  "react-utils": "/react-utils/static-2.5499",
  "react-virtualized": "/react-virtualized/static-2.103",
  "redux": "/redux/static-4.16",
  "StyleGuideUI": "/StyleGuideUI/static-3.492",
  "tinymce-plugins": "/tinymce-plugins/static-1.58074",
  "transmute": "/transmute/static-2.85",
  "ui-images": "/ui-images/static-2.1222",
  "UIComponents": "/UIComponents/static-3.8654",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9849",
  "styled-components": "/styled-components/static-2.94",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3559",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3615",
  "quartz-webpack": "/quartz-webpack/static-1.3562",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2395",
  "property-description-translator": "/property-description-translator/static-1.4065",
  "HeadJS": "/HeadJS/static-2.784",
  "framer-motion": "/framer-motion/static-1.75",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3364",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.155",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.226",
  "moment-timezone": "/moment-timezone/static-5.86",
  "jasmine": "/jasmine/static-4.4546",
  "jasmine-runner": "/jasmine-runner/static-1.6676",
  "dispatcher": "/dispatcher/static-1.140",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.862",
  "hubspotter-http": "/hubspotter-http/static-1.4808",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.559",
  "module-federation": "/module-federation/static-1.29",
  "quartz-auth": "/quartz-auth/static-1.1013",
  "quartz-head": "/quartz-head/static-1.1003",
  "quartz-i18n": "/quartz-i18n/static-1.1013",
  "quartz-routing": "/quartz-routing/static-1.768",
  "quartz-test": "/quartz-test/static-1.1013",
  "quartz-tracking": "/quartz-tracking/static-1.717",
  "trellis-components": "/trellis-components/static-1.2428",
  "ui-fonts": "/ui-fonts/static-1.970",
  "usage-tracker-container": "/usage-tracker-container/static-1.7574",
  "usage-tracker-core": "/usage-tracker-core/static-1.7434",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.161",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7476",
  "reference-resolvers": "/reference-resolvers/static-1.8409",
  "sanitize-text": "/sanitize-text/static-1.8375",
  "PatternValidationJS": "/PatternValidationJS/static-1.3124",
  "ReduxMessenger": "/ReduxMessenger/static-2.10592",
  "sanitize": "/sanitize/static-1.4703",
  "outpost": "/outpost/static-1.4389",
  "rpc-client-utils": "/rpc-client-utils/static-1.4889",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4622",
  "floating-ui": "/floating-ui/static-1.60",
  "hs-story-utils": "/hs-story-utils/static-1.9654",
  "react-aria": "/react-aria/static-1.69",
  "react-create-root-preference": "/react-create-root-preference/static-1.55",
  "tanstack-table": "/tanstack-table/static-1.58",
  "trellis-assets": "/trellis-assets/static-1.2409",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3162",
  "foundations-theming-base": "/foundations-theming-base/static-1.3664",
  "stylex": "/stylex/static-1.37",
  "hs-locale-management": "/hs-locale-management/static-1.240",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.9",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9538",
  "atom": "/atom/static-1.5304",
  "codemirror": "/codemirror/static-5.98",
  "content-assistance-lib": "/content-assistance-lib/static-1.8105",
  "ContentUtils": "/ContentUtils/static-1.69009",
  "data-token-picker": "/data-token-picker/static-1.16788",
  "file-manager-components": "/file-manager-components/static-1.24309",
  "FileManagerCore": "/FileManagerCore/static-1.39808",
  "FileManagerLib": "/FileManagerLib/static-1.39949",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8155",
  "hub-http-contrib": "/hub-http-contrib/static-1.3267",
  "interframe": "/interframe/static-3.4982",
  "layout-dnd-components": "/layout-dnd-components/static-1.12861",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11836",
  "property-translator": "/property-translator/static-1.5621",
  "react-codemirror": "/react-codemirror/static-1.10867",
  "react-colorpicker": "/react-colorpicker/static-2.10435",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8325",
  "rich-text-lib": "/rich-text-lib/static-1.20207",
  "tinymce-data": "/tinymce-data/static-1.41045",
  "tinymce-themes": "/tinymce-themes/static-1.56930",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10113",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5440",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16146",
  "bender-build-tools": "/bender-build-tools/static-1.3347",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10491",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10489",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5270",
  "base-ui": "/base-ui/static-1.17",
  "react-day-picker": "/react-day-picker/static-1.6",
  "trellis-theming": "/trellis-theming/static-1.1183",
  "tanstack-virtual": "/tanstack-virtual/static-1.35",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.299",
  "chirp-fetch": "/chirp-fetch/static-1.2114",
  "chatspot-core": "/chatspot-core/static-1.22518",
  "copilot-toolkit": "/copilot-toolkit/static-1.11703",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13258",
  "data-fetching-client": "/data-fetching-client/static-1.9884",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.4983",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8934",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29174",
  "usage-tracker": "/usage-tracker/static-1.7584",
  "cms-field-types": "/cms-field-types/static-1.5041",
  "content-icons-ui": "/content-icons-ui/static-1.2295",
  "integrations-lib": "/integrations-lib/static-1.16875",
  "customer-data-objects": "/customer-data-objects/static-1.7912",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1521",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4884",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.89",
  "graphql": "/graphql/static-1.85",
  "immer": "/immer/static-1.94",
  "immerable": "/immerable/static-1.4378",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9304",
  "video-components-external": "/video-components-external/static-1.12002",
  "video-data-lib": "/video-data-lib/static-1.35660",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.117",
  "audio-components": "/audio-components/static-1.6247",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29704",
  "FileManagerImages": "/FileManagerImages/static-1.37460",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1378",
  "html-to-image": "/html-to-image/static-1.57",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "salesImages": "/salesImages/static-1.530",
  "ui-universal-auth": "/ui-universal-auth/static-1.9250",
  "urlinator": "/urlinator/static-1.4760",
  "video-components": "/video-components/static-1.14004",
  "video-embed": "/video-embed/static-1.36494",
  "ts-schema": "/ts-schema/static-1.4237",
  "ContentData": "/ContentData/static-1.69084",
  "layout-data-lib": "/layout-data-lib/static-1.10161",
  "react-dnd-compat": "/react-dnd-compat/static-1.4842",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1771",
  "external-options-client-types": "/external-options-client-types/static-1.4285",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7120",
  "hs-promise-utils": "/hs-promise-utils/static-1.5823",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4004",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9208",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3288",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11374",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5707",
  "magpie-types": "/magpie-types/static-1.5167",
  "simple-logging-lib": "/simple-logging-lib/static-1.3277",
  "avatar-components": "/avatar-components/static-1.2724",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10053",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6809",
  "flux-actions": "/flux-actions/static-1.357",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5104",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14290",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5835",
  "laboratory-lib": "/laboratory-lib/static-3.7378",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8004",
  "redux-observable": "/redux-observable/static-1.11",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10490",
  "unified-auth": "/unified-auth/static-1.764",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.499",
  "breeze-engine-core": "/breeze-engine-core/static-1.799",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.82",
  "navigation-messaging": "/navigation-messaging/static-1.8011",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13044",
  "content-media-compositions": "/content-media-compositions/static-2.17051",
  "idb-keyval": "/idb-keyval/static-1.47",
  "media-bridge-lib": "/media-bridge-lib/static-1.19309",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1046",
  "social-insights-client-types": "/social-insights-client-types/static-1.22667",
  "advanced-menus-core": "/advanced-menus-core/static-1.15487",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12372",
  "ExportDialog": "/ExportDialog/static-6.10607",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34669",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3956",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4294",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.239",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4165",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7025",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3850",
  "persist-promise": "/persist-promise/static-1.3928",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5836",
  "reactive-lib": "/reactive-lib/static-1.947",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.563",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3237",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.311",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.887",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.890",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.1023",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.334",
  "slack-ui-library": "/slack-ui-library/static-1.10622",
  "js-cookie": "/js-cookie/static-1.18",
  "fsm": "/fsm/static-1.3964",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15486",
  "simple-menus-lib": "/simple-menus-lib/static-1.17003",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3739",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9949",
  "react-flip-move": "/react-flip-move/static-1.74"
}
};
